// Campus photo for /colleges/connecticut-college: CC BY-SA 4.0, by Beyond My Ken, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AConnecticut_College%2C_Fanning_Hall.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/connecticut-college/; credited under the photo.
const photo = {
    "slug": "connecticut-college",
    "alt": "Fanning Hall, a gabled stone building, with an observatory dome behind it at Connecticut College in New London, Connecticut",
    "src": "/colleges/connecticut-college/campus-1600.webp",
    "srcSmall": "/colleges/connecticut-college/campus-800.webp",
    "srcMid": "/colleges/connecticut-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/connecticut-college/og.jpg",
    "title": "Connecticut College, Fanning Hall",
    "author": "Beyond My Ken",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AConnecticut_College%2C_Fanning_Hall.jpg",
    "read": "2026-10-02"
};

export default photo;
